import { z } from 'zod';

export const iconSchema = z.object({
  id: z.number().int().positive().optional(),
  icon_pack_id: z.number().int().positive(),
  name: z.string().min(1, 'Name is required').max(60),
  content: z.string().min(20, 'Content is required'),
});

export type IconInput = z.infer<typeof iconSchema>;
